const ChevronDownIconV1 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6' fill='none'>
      <path d='M4.49999 6L-4.29138e-07 1.66869e-07L9 9.53674e-07L4.49999 6Z' fill='#121826' />
    </svg>
  );
};

export default ChevronDownIconV1;
